import ActionTypes from './ActionTypes';
export function setProgressPanelExpanded(expanded) {
  return {
    type: ActionTypes.WIZARD_SET_PROGRESS_PANEL_EXPANDED,
    payload: {
      expanded
    }
  };
}